(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("only-slide", [], factory);
	else if(typeof exports === 'object')
		exports["only-slide"] = factory();
	else
		root["only-slide"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'onlySlide',
    props: {
        slideViewWidth: {
            type: Number,
            default: 700
        },
        slideViewHeight: {
            type: Number,
            default: 300
        },
        slideData: {
            type: Array,
            default: function _default() {}
        }
    },
    data: function data() {
        return {
            isShowing: true,
            // transition 动态name
            slideAnimate: "",
            // 图集总数组
            sca: [],
            // 当前图集数组index位置
            caIdx: 0,
            // 当前图集图片index位置
            cpIdx: 0,
            // 当前图片url
            currUrl: "",
            // preview left
            previewLeft: 0,
            // moveable preview box current width
            currWidth: 0,
            // prevNextBtn vieible
            prevNextVisible: false
        };
    },
    mounted: function mounted() {
        // 初始获取预览可移动区域宽度
        this.moveablePreviewResetWidth();

        if (this.slideData.length > 0) {
            this.currUrl = this.slideData[this.caIdx].photo && this.slideData[this.caIdx].photo.length > 0 ? this.slideData[this.caIdx].photo[this.cpIdx].img : '';
        }
    },

    watch: {
        slideData: {
            handler: function handler(val, oldVal) {
                this.caIdx = 0;
                this.cpIdx = 0;
                this.currUrl = val[this.caIdx].photo && val[this.caIdx].photo.length > 0 ? val[this.caIdx].photo[this.cpIdx].img : '';
            },

            deep: true
        }
    },
    methods: {
        // 切换图片 逻辑
        cutPage: function cutPage(type) {
            this.sca = this.slideData;
            switch (type) {
                case "prev":
                    if (this.cpIdx == 0) {
                        if (this.caIdx == 0) {
                            this.caIdx = this.sca.length - 1;
                        } else {
                            this.caIdx--;
                        }
                        this.moveablePreviewResetWidth();
                        this.cpIdx = this.sca[this.caIdx].photo.length == 0 ? 0 : this.sca[this.caIdx].photo.length - 1;
                        this.currUrl = this.sca[this.caIdx].photo.length > 0 ? this.sca[this.caIdx].photo[this.cpIdx].img : '';
                    } else {
                        this.cpIdx--;
                        this.currUrl = this.sca[this.caIdx].photo[this.cpIdx].img;
                    }
                    this.isShowing = !this.isShowing;
                    this.slideAnimate = "slideright";
                    break;
                case "next":
                    if (this.cpIdx == (this.sca[this.caIdx].photo.length == 0 ? 0 : this.sca[this.caIdx].photo.length - 1)) {
                        this.cpIdx = 0;
                        if (this.caIdx == this.sca.length - 1) {
                            this.caIdx = 0;
                        } else {
                            this.caIdx++;
                        }
                        this.moveablePreviewResetWidth();
                        this.currUrl = this.sca[this.caIdx].photo.length > 0 ? this.sca[this.caIdx].photo[this.cpIdx].img : '';
                    } else {
                        this.cpIdx++;
                        this.currUrl = this.sca[this.caIdx].photo[this.cpIdx].img;
                    }
                    this.isShowing = !this.isShowing;
                    this.slideAnimate = "slideleft";
                    break;
            }
        },

        // 切换图集 按钮逻辑
        cutAlbum: function cutAlbum(index) {
            this.sca = this.slideData;
            this.caIdx = index;
            this.cpIdx = 0;
            this.currUrl = this.sca[this.caIdx].photo.length > 0 ? this.sca[this.caIdx].photo[this.cpIdx].img : '';
            this.moveablePreviewResetWidth();
        },

        // 预览区图片滚动
        cutPreview: function cutPreview(type) {
            if (this.slideData.length == 0) return;
            var pvw = this.slideViewWidth - 70;
            var sw = 85;
            var hideBoxWidth = this.$refs.hidebox.getBoundingClientRect().width;
            switch (type) {
                case 'prev':
                    if (this.previewLeft == 0) return;
                    this.previewLeft += sw;
                    this.currWidth += sw;
                    break;
                case 'next':
                    if (this.currWidth - pvw <= 5) return;
                    this.previewLeft -= sw;
                    this.currWidth -= sw;
                    break;
            };
        },

        // 点击预览图片
        clickPreview: function clickPreview(index) {
            this.sca = this.slideData;
            if (this.cpIdx == index) return;
            if (this.cpIdx < index) {
                this.slideAnimate = "slideleft";
            } else {
                this.slideAnimate = "slideright";
            }
            this.isShowing = !this.isShowing;
            this.cpIdx = index;
            this.currUrl = this.sca[this.caIdx].photo[this.cpIdx].img;
        },

        // 预览区图集切换
        cutAlbumInPreview: function cutAlbumInPreview(type) {
            this.sca = this.slideData;
            if (type == "prev") {
                this.caIdx--;
                this.cpIdx = 0;
                this.currUrl = this.sca[this.caIdx].photo && this.sca[this.caIdx].photo.length > 0 ? this.sca[this.caIdx].photo[this.cpIdx].img : '';
                this.moveablePreviewResetWidth();
            } else {
                this.caIdx++;
                this.cpIdx = 0;
                this.currUrl = this.sca[this.caIdx].photo && this.sca[this.caIdx].photo.length > 0 ? this.sca[this.caIdx].photo[this.cpIdx].img : '';
                this.moveablePreviewResetWidth();
            }
        },

        // reset width
        moveablePreviewResetWidth: function moveablePreviewResetWidth() {
            var self = this;
            self.previewLeft = 0;
            self.$nextTick(function () {
                self.currWidth = self.$refs.hidebox.getBoundingClientRect().width;
            });
        },

        // prevNextBtn vieible
        hoverPrevNextVisible: function hoverPrevNextVisible() {
            if (this.slideData.length == 0) return;
            this.prevNextVisible = true;
        },
        hoverPrevNextHide: function hoverPrevNextHide() {
            if (this.slideData.length == 0) return;
            this.prevNextVisible = false;
        }
    }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__only_slide_vue__ = __webpack_require__(2);

// 导入组件 
var vueOnlySlide = {
    install: function install(Vue, options) {
        Vue.component(__WEBPACK_IMPORTED_MODULE_0__only_slide_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__only_slide_vue__["a" /* default */]);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(vueOnlySlide);
}

/* harmony default export */ __webpack_exports__["default"] = (vueOnlySlide);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_only_slide_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_da250fda_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_only_slide_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da250fda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_only_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_da250fda_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_only_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("d7467d42", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "ul[data-v-da250fda]{list-style:none}.clear[data-v-da250fda]:after{content:\"\";height:0;display:block;clear:both}.no-album[data-v-da250fda]{background:#f5f5f5;color:#969696!important}.no-pic[data-v-da250fda]{background:#eee;font-size:14px;height:100%;text-align:center;color:#969696;line-height:100%;vertical-align:middle}.preview-img[data-v-da250fda]{width:100%;height:100%;background-size:100% auto;background-position:50%;background-repeat:no-repeat;background-color:#eee}.preview-no-pic[data-v-da250fda]{text-align:center;font-size:14px;color:#969696;background:#eee}.o-slide-item[data-v-da250fda],.only-slide[data-v-da250fda]{position:relative;width:100%;height:100%}.o-sldie-container[data-v-da250fda]{margin-bottom:100px}.only-slide[data-v-da250fda]{overflow:hidden}.o-slide-wapper[data-v-da250fda]{width:auto;height:100%;white-space:nowrap}.o-slide-item[data-v-da250fda]{position:absolute;top:0;left:0;display:inline-block;vertical-align:top;background-size:100% auto;background-position:50%;background-repeat:no-repeat}.o-slide-item span[data-v-da250fda]{position:absolute;left:10px;bottom:10px;display:inline-block;padding:3px 10px;background:rgba(0,0,0,.4);color:#fff;border-radius:3px;max-width:50%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px}.o-next[data-v-da250fda],.o-prev[data-v-da250fda]{position:absolute;top:0;bottom:0;margin:auto 0;width:55px;height:55px;font-size:20px;line-height:55px;color:#fff;cursor:pointer;background:rgba(0,0,0,.4);text-align:center;border-radius:50%;transition:all .2s}.o-next img[data-v-da250fda],.o-prev img[data-v-da250fda]{vertical-align:middle;display:inline-block;width:32px;height:32px}.o-prev[data-v-da250fda]{left:10px}.o-next[data-v-da250fda]{right:10px}.pagination[data-v-da250fda]{position:absolute;right:6px;bottom:6px;font-size:12px;color:#fff;text-shadow:0 0 7px rgba(0,0,0,.9)}.photo-album-btn[data-v-da250fda]{padding:0;width:100%;line-height:20px;font-size:16px;background:#fff;margin-bottom:10px}.photo-album-btn li[data-v-da250fda]{float:left;padding:3px 8px;margin-right:5px;color:#454545;border-radius:3px;cursor:pointer}.photo-album-btn li.active[data-v-da250fda]{background:#454545;color:#fff}.o-preview[data-v-da250fda]{margin-top:15px;width:100%;height:60px;padding:0 35px;line-height:60px;position:relative;box-sizing:border-box}.o-preview .o-preview-wapper[data-v-da250fda]{position:relative;width:100%;height:100%;overflow:hidden}.o-preview ul[data-v-da250fda]{position:absolute;top:0;left:0;width:auto;height:100%;padding:0;margin:0;white-space:nowrap;text-align:left;transition:all .3s}.o-preview ul li[data-v-da250fda]{vertical-align:top;display:inline-block;width:80px;height:100%;margin-right:5px;cursor:pointer;transition:all .2s}.o-preview ul li[data-v-da250fda]:hover{opacity:1!important}.o-preview ul li img[data-v-da250fda]{width:100%;height:100%}.o-preview-next[data-v-da250fda],.o-preview-prev[data-v-da250fda]{position:absolute;top:0;bottom:0;margin:auto 0;width:35px;height:100%;font-size:28px;line-height:60px;color:#454545;cursor:pointer;opacity:.5;transition:all .2s}.o-preview-next[data-v-da250fda]:hover,.o-preview-prev[data-v-da250fda]:hover{opacity:1}.o-preview-prev[data-v-da250fda]{left:0;text-align:left}.o-preview-next[data-v-da250fda]{right:0;text-align:right}.cut-album-btn[data-v-da250fda]{text-align:center;font-size:12px;background:#f9f9f9;color:#454545}.slideleft-enter-active[data-v-da250fda]{animation:slideLeftEnter-data-v-da250fda .5s}.slideleft-leave-active[data-v-da250fda]{animation:slideLeftLeave-data-v-da250fda .5s}@keyframes slideLeftEnter-data-v-da250fda{0%{transform:translateX(100%);opacity:0}to{transform:translateX(0);opacity:1}}@keyframes slideLeftLeave-data-v-da250fda{0%{transform:translateX(0);opacity:1}to{transform:translateX(-100%);opacity:0}}.slideright-enter-active[data-v-da250fda]{animation:slideRightEnter-data-v-da250fda .5s}.slideright-leave-active[data-v-da250fda]{animation:slideRightLeave-data-v-da250fda .5s}@keyframes slideRightEnter-data-v-da250fda{0%{transform:translateX(-100%);opacity:0}to{transform:translateX(0);opacity:1}}@keyframes slideRightLeave-data-v-da250fda{0%{transform:translateX(0);opacity:1}to{transform:translateX(100%);opacity:0}}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-sldie-container",style:({width:_vm.slideViewWidth + 'px'})},[_c('ul',{staticClass:"photo-album-btn clear"},[_vm._l((_vm.slideData),function(item,index){return _c('li',{key:index,class:{active:_vm.caIdx==index?true:false},on:{"click":function($event){return _vm.cutAlbum(index)}}},[_vm._v("\n            "+_vm._s(item.albumName)+"（"+_vm._s(item.photo.length)+"）\n        ")])}),_vm._v(" "),(_vm.slideData.length == 0)?_c('li',{staticClass:"no-album"},[_vm._v("暂无图集")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"only-slide",style:({height:_vm.slideViewHeight + 'px'}),on:{"mouseover":_vm.hoverPrevNextVisible,"mouseleave":_vm.hoverPrevNextHide}},[_c('div',{staticClass:"o-slide-wapper"},[_c('transition',{attrs:{"name":_vm.slideAnimate,"tag":"div"}},[_c('div',{key:_vm.isShowing,staticClass:"o-slide-item",style:({backgroundImage: 'url('+ _vm.currUrl +')'})},[(!_vm.currUrl)?_c('div',{staticClass:"no-pic",style:({lineHeight: _vm.slideViewHeight + 'px'})},[_vm._v("暂无图片")]):_vm._e(),_vm._v(" "),(_vm.prevNextVisible && (_vm.slideData[_vm.caIdx].photo && _vm.slideData[_vm.caIdx].photo.length > 0) ? _vm.slideData[_vm.caIdx].photo[_vm.cpIdx].descr : false)?_c('span',[_vm._v(_vm._s(_vm.slideData[_vm.caIdx].photo[_vm.cpIdx].descr))]):_vm._e()])])],1),_vm._v(" "),(_vm.prevNextVisible)?_c('div',{staticClass:"o-prev",on:{"click":function($event){return _vm.cutPage('prev')}}},[_c('img',{attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCODNERjI0OTc4RTkxMUU3QjlEQkU0NDIyMTVBRTlCRiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCODNERjI0QTc4RTkxMUU3QjlEQkU0NDIyMTVBRTlCRiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkI4M0RGMjQ3NzhFOTExRTdCOURCRTQ0MjIxNUFFOUJGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkI4M0RGMjQ4NzhFOTExRTdCOURCRTQ0MjIxNUFFOUJGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/fXlQgAAAZlJREFUeNrs2+GtgkAMB3DOCRjBDXQERmCEcwJXcQNwAzZgBNzEEbCXwCeDHHetaXttcnnJi3m5/y96Qulz8zxXJdepKrwMwAAMwAAMwAAMwACSyzmHuqDusCZYb1gdrHr5PU2FS+GchbyXbv6uCWOfm/vnArARfi1PBcDiDAjh4Yf/8ZKz2kMwInyoQSVAZPgnHIIvdYfgzmd+rR5rn6wOwaPhVQGkhFcDkBpeBUBOePEAueFFA2CEFwuAFV4kAGZ4cQDY4UUBUIQXA0AVXgQAZXj2ANThWQPAaqnDUwJg9AOaiPt5XzGtfzRELiBdawbYe3tfYY1cETCeC4R21U0sAuLXoI84DKdUBCkXQmQIki6FSRCk3QyhI0i8HUZFkNoQQUOQ3BJDQZDeFM1G0NAWz0LQ8mAkGUHTo7EkBG0PRw8jqBuROYqgckYoEmFUPSQViXBVOyTlnOsj+gmt2iGpSASyISlug5J+q6NM9RFwuSGwx1hhP80yORZmAwf4+48VgOTdZ/81VngZgAEYgAEYgAEYQLn1EWAAQFrgEZNBEzkAAAAASUVORK5CYII=","alt":""}})]):_vm._e(),_vm._v(" "),(_vm.prevNextVisible)?_c('div',{staticClass:"o-next",on:{"click":function($event){return _vm.cutPage('next')}}},[_c('img',{attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMzA5Mzc1Njc4RTkxMUU3OUM5RUJCQUI2ODQ1RDNERiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMzA5Mzc1Nzc4RTkxMUU3OUM5RUJCQUI2ODQ1RDNERiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkEzMDkzNzU0NzhFOTExRTc5QzlFQkJBQjY4NDVEM0RGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkEzMDkzNzU1NzhFOTExRTc5QzlFQkJBQjY4NDVEM0RGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+bVSsJwAAAaFJREFUeNrsmoFtwkAMRXOoAzAKHYEN2KDpBO1GMEI3aDYANmCDdoOrUwWpagWBO//K32dLlqUkSu4/InOxnXLOXcu26Bq3ABAAAkAACAABIAC0aw+oG6eUvqPsNF8lbMRP4js5Pmg+p3onO94A4dO9d/mv9doAqtaJAiC+ypettwIAmQM2V85ttd8Ei0nwbea8CQgLYBI8SBjMQwAnwaX4Ps9b7y4J/lggFIJ5AGgIFACQEGgAoCBQAUBAoAOgDYESgCYEWgBaEKgBaECgB1ALwQWAGghuAJRCcAWgBELtOhOqO3yuCZZCkPAuvpq59FH84K4qLPA+JaxvEFddSzBbFp8gHJvtC4wVZQlPM5cNGg8ylQSvlNN/29brv8DN4j3uA+4S720neLd4T98CReK9fA0Wi/dQD6gSz14RqhbPXBNUEc9aFVYTz9gXUBXP1hlSF8/UG4SIZ+kOw8SbB4AWzzwkpSKeeUiqm2YGnz0PSZ2si/+PGaE94rVnSoJjjX+cBPuYYLxY+wFhfQEWi3H5ABAAAkAACAABIAA0a18CDAB6UWSzZ1MpswAAAABJRU5ErkJggg==","alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pagination"},[_vm._v(_vm._s(_vm.slideData[_vm.caIdx] && _vm.slideData[_vm.caIdx].photo && _vm.slideData[_vm.caIdx].photo.length > 0 ? (_vm.cpIdx + 1) : 0)+"/"+_vm._s(_vm.slideData[_vm.caIdx] && _vm.slideData[_vm.caIdx].photo ? _vm.slideData[_vm.caIdx].photo.length : 0))])]),_vm._v(" "),_c('div',{staticClass:"o-preview"},[_c('div',{staticClass:"o-preview-wapper"},[_c('ul',{ref:"hidebox",style:({left:_vm.previewLeft+'px'})},[(_vm.caIdx == 0 ? false : true)?_c('li',{staticClass:"cut-album-btn",on:{"click":function($event){return _vm.cutAlbumInPreview('prev')}}},[_vm._v("上一图集")]):_vm._e(),_vm._v(" "),_vm._l((_vm.slideData[_vm.caIdx] && _vm.slideData[_vm.caIdx].photo ? _vm.slideData[_vm.caIdx].photo : 0),function(item,index){return _c('li',{key:index,style:({opacity: _vm.cpIdx == index ? 1 : .4}),on:{"click":function($event){return _vm.clickPreview(index)}}},[_c('div',{staticClass:"preview-img",style:({backgroundImage: 'url('+ item.img +')'})})])}),_vm._v(" "),(!_vm.slideData[_vm.caIdx] || !_vm.slideData[_vm.caIdx].photo || _vm.slideData[_vm.caIdx].photo.length == 0)?_c('li',{staticClass:"preview-no-pic"},[_vm._v("暂无图片")]):_vm._e(),_vm._v(" "),((_vm.slideData.length == 0 || _vm.caIdx == _vm.slideData.length - 1) ? false : true)?_c('li',{staticClass:"cut-album-btn",on:{"click":function($event){return _vm.cutAlbumInPreview('next')}}},[_vm._v("下一图集")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"o-preview-prev",on:{"click":function($event){return _vm.cutPreview('prev')}}},[_vm._v("《")]),_vm._v(" "),_c('div',{staticClass:"o-preview-next",on:{"click":function($event){return _vm.cutPreview('next')}}},[_vm._v("》")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// only-slide.js